import { useRef } from 'react'
import { Marker } from 'react-leaflet'
import { useSearchParams } from 'react-router-dom'
import dayjs from 'dayjs'
import { createMarkerColor } from 'utils/helpers'
import { v4 as uuid } from 'uuid'
import { ImagesPng } from 'assets/images'

export const CopyMarkerItem = ({
  item,
  mapRef,
  avatar,
  isAuth
}) => {
  const markerRef = useRef()
  let mouseDownOnMarkerRef = useRef(false)
  const [searchParams, setSearchParams] = useSearchParams()

  const validDate = dayjs(item?.last_accessed)
  const iconMarker = createMarkerColor(
    validDate,
    avatar ?? ImagesPng.DefaultImage,
    item?.is_friends,
    isAuth
  )

  const handleClick = (e) => {
    if (isAuth) {
      markerRef.current.closePopup()

      const trueLng = e.latlng.lng > 180 ? e.latlng.lng - 360 : e.latlng.lng + 360

      mapRef.current.setView([
        e.latlng.lat,
        trueLng
      ], localStorage.getItem('zoom'), { animate: true })

      setTimeout(() => {
        setSearchParams({ id: item.id })
      }, 300)
    }
  }

  return (
    <Marker
      zIndexOffset={-99999}
      eventHandlers={{
        click: (e) => handleClick(e),
        mousedown: () => {
          mouseDownOnMarkerRef.current = true
        },
        mouseup: (e) => {
          if (mouseDownOnMarkerRef.current && item?.coordinates[0] >= (84.5 * 2)) {
            handleClick(e)
          }

          mouseDownOnMarkerRef.current = false
        },
        mouseout: () => {
          mouseDownOnMarkerRef.current = false
        },
        touchStart: () => {
          mouseDownOnMarkerRef.current = true
        },
        touchEnd: (e) => {
          if (mouseDownOnMarkerRef.current && item?.coordinates[0] >= (84.5 * 2)) {
            handleClick(e)
          }

          mouseDownOnMarkerRef.current = false
        },
        touchCancel: () => {
          mouseDownOnMarkerRef.current = false
        }
      }}
      key={uuid()}
      icon={iconMarker}
      position={item?.coordinates}
      ref={markerRef}
      {...(isAuth ? { title: item?.id } : {})}
    />
  )
}
